/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class ModelGrid extends SiteEntityGrid<ModelRow, any> {
        protected getColumnsKey() { return 'Data.Model'; }
        protected getDialogType() { return ModelDialog; }
        protected getIdProperty() { return ModelRow.idProperty; }
        protected getLocalTextPrefix() { return ModelRow.localTextPrefix; }
        protected getService() { return ModelService.baseUrl; }

        private requireRefresh: boolean;

        constructor(container: JQuery) {
            super(container);
        }

        protected initDialog(dlg: Serenity.Widget<any>) {
            super.initDialog(dlg);
            dlg.element.one('dialogclose, panelclose', () => {
                if (this.requireRefresh) {
                    window.setTimeout(() => window.location.reload(), 100);
                }
            });
        }

        protected subDialogDataChange() {
            super.subDialogDataChange();
            this.requireRefresh = true;
            if (!$('.ui-dialog:visible, .s-Panel:visible').length)
                window.setTimeout(() => window.location.reload(), 100);
        }
    }
}